module.exports = __webpack_public_path__ + "static/media/HESSAPP.31608ef6.mp4";